import { Component } from '@angular/core';
import {
  CountryItem,
  DtoTravelBookingCreate,
  DtoTravelBookingRoomMember,
  Invitation,
  MediaItem,
  TravelItem,
  TravelPackage,
} from '../../../api/models';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  BookingService,
  CountryService,
  InvitationService,
  TravelService,
} from '../../../api/services';
import { MenuItem, MessageService } from 'primeng/api';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  SelectControlValueAccessor,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  of,
  switchMap,
} from 'rxjs';
import { CountryControllerGetAll$Params } from '../../../api/fn/country/country-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { enumPaymentMethod } from '../../../shared/utils/enum-payment-method';
import { enumDocumentType } from '../../../shared/utils/enum-document-type';
import { enumRoomType } from '../../../shared/utils/enum-room-type';
import { correctDate } from '../../../shared/utils/utils';
import { addDays, isAfter, isBefore, isEqual } from 'date-fns';
import { Location } from '@angular/common';
import { response } from 'express';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../guards/services/auth.service';
import { FormValidatorsService } from '../../../shared/services/form-validators.service';
import {
  foreignFiscalCodeValidator,
  italianFiscalCodeValidator,
} from '../../../customValidators/fiscal-code.validator';

@Component({
  selector: 'app-travel-join',
  templateUrl: './travel-join.component.html',
  styleUrl: './travel-join.component.scss',
})
export class TravelJoinComponent {
  travel?: TravelItem;
  items: MenuItem[] | undefined;
  menuIndex = 0;
  adult_customers = [1, 2, 3, 4];
  kid_customers = [0, 1, 2, 3, 4];
  activeIndex: number | undefined = undefined;
  loading = false;
  genders = [
    { id: 'M', name: 'Uomo' },
    { id: 'F', name: 'Donna' },
    { id: 'X', name: 'Non specificato' },
  ];
  id_type = [
    { id: enumDocumentType.ID, name: "Carta d'identità" },
    { id: enumDocumentType.PT, name: 'Passaporto' },
  ];
  autocompleteCountries$ = new BehaviorSubject<string>('');
  suggestedCountries: CountryItem[] = [];
  enumPaymentMethod = enumPaymentMethod;
  purchased_with_optional_flight = new FormControl(false);
  overbooking = false;

  //booked_members_n = 0;
  //max_members = 0;
  maxMembersExceeded = false;
  isGuest = false;
  // account_holder_guest = new FormControl<boolean>(false);
  insuranceTextDialog = false;
  luggage_attachment?: MediaItem;
  cancellation_attachment?: MediaItem;
  environmentMediaUrl = environment.mediaUrl;
  today = new Date();
  selectedPackages: { form: FormGroup; package: TravelPackage }[] = [];
  packageMap = new Map<number, TravelPackage>();
  maxMembersExceededMap = new Map<number, boolean>();
  expandedTabIndex: number | null = null;
  environment = environment;

  frmJoin = new FormGroup({
    with_flights: new FormControl<boolean | undefined>(undefined),
    rooms: new FormArray<
      FormGroup<{
        n_adults: FormControl;
        n_children: FormControl;
        n_infants: FormControl;
        room_type: FormControl;
        dbl_type: FormControl;
        price_room: FormControl;
        members: FormArray<
          FormGroup<{
            name: FormControl;
            last_name: FormControl;
            date_of_birth: FormControl;
            fiscal_code: FormControl;
            gender: FormControl;
            disabled: FormControl;
            document_type: FormControl;
            document_number: FormControl;
            document_exp_date: FormControl;
            document_release_date: FormControl;
            nationality: FormControl;
            phone_number: FormControl;
            email_address: FormControl;
            member_type: FormControl;
            tmp_account_holder_guest: FormControl;
          }>
        >;
      }>
    >([]),
    selected_packages: new FormArray<
      FormGroup<{
        package_id: FormControl<number>;
        purchased: FormArray<
          FormGroup<{
            related_package_id: FormControl<number>;
            price_per_person: FormControl<number>;
            price_per_infant: FormControl<number>;
            price_per_children: FormControl<number>;
            n_adults: FormControl<number>;
            n_children: FormControl<number>;
            n_infants: FormControl<number>;
            notes: FormControl<string | undefined>;
            members: FormArray<
              FormGroup<{
                name: FormControl;
                last_name: FormControl;
                date_of_birth: FormControl;
                fiscal_code: FormControl;
                gender: FormControl;
                disabled: FormControl;
                document_type: FormControl;
                document_number: FormControl;
                document_exp_date: FormControl;
                document_release_date: FormControl;
                nationality: FormControl;
                phone_number: FormControl;
                email_address: FormControl;
                member_type: FormControl;
                is_account_holder: FormControl;
              }>
            >;
          }>
        >;
      }>
    >([]),
    // selected_packages: new FormArray<
    //   FormGroup<{
    //     package_id: FormControl<number>;
    //     n_adults: FormControl<number>;
    //     n_children: FormControl<number>;
    //     n_infants: FormControl<number>;
    //     members: FormArray<
    //       FormGroup<{
    //         name: FormControl;
    //         last_name: FormControl;
    //         date_of_birth: FormControl;
    //         fiscal_code: FormControl;
    //         gender: FormControl;
    //         disabled: FormControl;
    //         document_type: FormControl;
    //         document_number: FormControl;
    //         document_exp_date: FormControl;
    //         member_type: FormControl;
    //         tmp_account_holder_guest: FormControl;
    //       }>
    //     >;
    //   }>
    // >([]),
    addl_service: new FormArray<
      FormGroup<{
        title: FormControl;
        price: FormControl;
        qty: FormControl;
      }>
    >([]),
    accountholder_name: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_last_name: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_country_iso: new FormControl<CountryItem | null>(null, {
      validators: [Validators.required],
      nonNullable: true,
    }),
    accountholder_province: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_city: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_address: new FormControl(undefined, Validators.required),
    accountholder_zip_code: new FormControl(undefined, Validators.required),
    accountholder_mobile_phone: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyNumberValidator,
    ]),
    accountholder_email: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),
    accountholder_fiscal_code: new FormControl(undefined, [
      Validators.required,
      italianFiscalCodeValidator(),
    ]),
    confirm_email: new FormControl({ value: '', disabled: true }, [
      Validators.required,
      Validators.email,
    ]),
    payment_method: new FormControl<enumPaymentMethod | undefined>(
      undefined,
      Validators.required,
    ),
    third_party_booking: new FormControl<boolean>(false, Validators.required),
  });

  addl_service_total = 0;
  pckgs_full_total = 0;
  invitation?: Invitation;
  notRightUser = false;

  isDblRoom = false;
  bookingDate? = new Date().toISOString();
  constructor(
    private ar: ActivatedRoute,
    private router: Router,
    private travelService: TravelService,
    private countryService: CountryService,
    private bookingService: BookingService,
    private messageService: MessageService,
    private slugifyPipe: SlugifyPipe,
    private invitationService: InvitationService,
    private title: Title,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    //PER LA VALIDAZIONE CODICE FISCALE,SE IT O SE ESTERO
    const countryControl = this.frmJoin.get('accountholder_country_iso');
    const cfControl = this.frmJoin.get('accountholder_fiscal_code');
    countryControl?.valueChanges.subscribe((country) => {
      if (!cfControl) return;
      if (country) {
        if (country?.ISO === 'IT') {
          (cfControl.setValidators([
            Validators.required,
            italianFiscalCodeValidator(),
          ]),
            cfControl.updateValueAndValidity());
        } else {
          (cfControl.setValidators([
            Validators.required,
            foreignFiscalCodeValidator(),
          ]),
            cfControl.updateValueAndValidity());
        }
      }
    }); //^PER LA VALIDAZIONE CODICE FISCALE,SE IT O SE ESTERO
    this.title.setTitle('SocialTravels - Partecipa');
    this.getOneTravel();
    this.autocompleteCountries$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: CountryControllerGetAll$Params = {
              query,
            };
            return this.countryService.countryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        }),
      )
      .subscribe({
        next: (res) => {
          this.suggestedCountries = res.data.list;
          if (this.suggestedCountries.length === 1) {
            this.frmJoin
              .get('accountholder_country_iso')
              ?.setValue(this.suggestedCountries[0]);
          }
        },
      });

    this.frmJoin.get('accountholder_email')!.valueChanges.subscribe((value) => {
      if (value) {
        this.frmJoin.get('confirm_email')!.enable();
      } else {
        this.frmJoin.get('confirm_email')!.disable();
        this.frmJoin.get('confirm_email')!.setValue('');
      }
    });

    this.ar.queryParams.subscribe((p) => {
      if (p['third-party-booking']) {
        this.frmJoin.get('third_party_booking')?.setValue(true);
      }
      if (p['invite']) {
        this.invitationService
          .invitationControllerFindOne({ identifier: p['invite'] })
          .subscribe({
            next: (res) => {
              this.invitation = res.data.invitation;
              if (
                this.auth.user.value?.email === res.data.invitation.to_email
              ) {
                this.notRightUser = false;
              } else {
                this.notRightUser = true;
                this.router.navigate(['/redirect-to']);
              }
            },
          });
      }
    });

    if (this.ar.snapshot.data['guest']) {
      this.isGuest = this.ar.snapshot.data['guest'];
      // this.frmJoin.get('third_party_booking')?.setValue(true);
    }
  }
  //controllo che la data di prenotazione sia prima della data ultima di prenotazione
  isBeforeDeadline(): boolean {
    const bookingDeadline = new Date(this.travel!.booking_deadline);
    const today = new Date(this.bookingDate!);

    return isBefore(today, bookingDeadline);
  }
  //controllo che la data di prenotazione sia prima della data di scadenza del saldo
  isBeforePayoffDueDate(): boolean {
    const today = new Date(this.bookingDate!);
    const payoffDueDate = new Date(this.travel!.payoff_due_date);

    return isBefore(today, payoffDueDate);
  }
  //controllo che la data di prenotazione sia prima della data ultima di prenotazione e >= della data di scadenza del saldo
  isOnlyFullPayment(): boolean {
    const bookingDeadline = new Date(this.travel!.booking_deadline);
    const today = new Date(this.bookingDate!);
    const payoffDueDate = new Date(this.travel!.payoff_due_date);

    return (
      isBefore(today, bookingDeadline) &&
      (isAfter(today, payoffDueDate) || isEqual(today, payoffDueDate))
    );
  }

  filterCountries(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteCountries$.next(query);
  }

  getOneTravel() {
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        const id = p['id'];
        this.loading = true;
        this.travelService.travelControllerGetTravel({ id }).subscribe({
          next: (res) => {
            this.travel = res.data;

            if (this.frmJoin.get('third_party_booking')?.value === false) {
              if (this.isOnlyFullPayment()) {
                this.frmJoin
                  .get('payment_method')
                  ?.setValue(enumPaymentMethod.STRIPE_TRANSFER); //saldo
              } else if (
                (this.isBeforeDeadline() && this.isBeforePayoffDueDate()) ||
                this.travel!.booking_deadline
              ) {
                this.frmJoin
                  .get('payment_method')
                  ?.setValue(enumPaymentMethod.STRIPE_ADVANCE); //acconto e saldo
              }
            }

            if (this.travel?.draft) {
              this.router.navigateByUrl('/');
            }
            // if(this.travel.has_flights === false){
            //   this.frmJoin.get('with_flights')?.setValue(false);
            // }else{
            //   this.frmJoin.get('with_flights')?.setValue(true);
            // }

            if (this.travel.has_flights) {
              //se il travel ha i voli
              this.frmJoin.get('with_flights')?.setValue(true); //setto has flights a true
              if (this.travel?.optional_flight_purchase) {
                //se il viaggio ha l'acquisto del volo opzionale
                this.purchased_with_optional_flight.valueChanges.subscribe(
                  (v) => {
                    //sottoscrivo al value
                    if (v === false) {
                      //se non voglio acquistare il volo opzionale al di fuori di ST
                      this.frmJoin.get('with_flights')?.setValue(true); //compro quello del viaggio
                    }
                    if (v === true) {
                      //se voglio acquistare il volo opzionale al di fuori di ST
                      this.frmJoin.get('with_flights')?.setValue(false); //non compro quello del viaggio
                    }
                  },
                );
              }
            } else {
              this.frmJoin.get('with_flights')?.setValue(false);
            }
            this.setBreadcrumb();
            this.checkForAvailability();
            if (this.travel?.pricing_mode === 1) {
              this.addRoom();
            } else {
              if (this.travel?.price_packages) {
                for (const pkg of this.travel.price_packages) {
                  this.packageMap.set(pkg.id, pkg);
                }
              }
            }

            for (let i = 0; i < this.travel.addl_services.length; i++) {
              this.addService(i);
            }
            if (this.travel?.attachments) {
              this.luggage_attachment = this.travel.attachments.find((x) =>
                x.attachment.path.includes('luggage-insurance'),
              )?.attachment;
              this.cancellation_attachment = this.travel.attachments.find((x) =>
                x.attachment.path.includes('cancellation-insurance'),
              )?.attachment;
            }
            this.loading = false;
          },
        });
      }
    });
  }

  setBreadcrumb() {
    const slugifyName = this.slugifyPipe.transform(this.travel!.name);
    this.items = [
      { label: 'Homepage', routerLink: '/' },
      {
        label: this.travel?.countries[0].country.name,
        routerLink: [
          '/viaggi-di-gruppo',
          this.travel?.countries[0].country.ISO,
          this.travel?.countries[0].country.name,
        ],
      },
      {
        label: this.travel?.name,
        routerLink: [
          '/viaggi-di-gruppo',
          this.travel?.countries[0].country.ISO,
          this.travel?.countries[0].country.name,
          this.travel?.id,
          slugifyName,
        ],
      },
      { label: 'Prenotazione ' },
    ];
  }

  goTo(n: number) {
    this.menuIndex = n;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (this.travel?.pricing_mode === 1) {
      this.frmJoin
        .get('accountholder_name')
        ?.setValue(this.getFrmMembersControls(0)[0].get('name')?.value);
      this.frmJoin
        .get('accountholder_last_name')
        ?.setValue(this.getFrmMembersControls(0)[0].get('last_name')?.value);
    }
  }

  checkForAvailability() {
    let n_adults_each_room = 0;
    for (let r of this.frmRooms.controls) {
      n_adults_each_room += r.value.n_adults;
    }
    if (
      n_adults_each_room >
      this.travel?.availability?.max! - this.travel?.availability?.booked!
    ) {
      this.maxMembersExceeded = true;
    } else {
      this.maxMembersExceeded = false;
    }
  }

  get frmRoomsControls() {
    return <FormGroup[]>(this.frmJoin.get('rooms') as FormArray).controls;
  }
  get frmRooms() {
    return this.frmJoin.get('rooms') as FormArray;
  }

  get fullPaymentLegacy() {
    let advanceTotal = 0;
    let fullTotal = 0;

    for (let r of this.frmRoomsControls) {
      const n_adults = r.get('n_adults')?.value || 0;
      const n_children = r.get('n_children')?.value || 0;
      const n_infants = r.get('n_infants')?.value || 0;

      const purchaseTotal =
        n_adults * (r.get('price_room')?.value || 0) -
        n_children * (this.travel?.price_sub_child || 0) -
        n_infants * (this.travel?.price_sub_infant || 0);

      fullTotal += purchaseTotal;

      if (this.travel?.checkout_advance) {
        // L'acconto si calcola solo sugli adulti
        advanceTotal += this.travel.checkout_advance * n_adults;
      }
      if (this.purchased_with_optional_flight.value === true) {
        fullTotal -= this.travel?.optional_flight_purchase_discount!;
      }
    }
    return { advanceTotal, fullTotal };
  }

  get fullPaymentPkgs() {
    let advanceTotal = 0;
    let fullTotal = 0;
    let tot_participants = 0;

    const selectedPackages = this.frmJoin.get('selected_packages') as FormArray;
    if (!selectedPackages || !this.travel?.price_packages) {
      return { advanceTotal, fullTotal };
    }

    for (let pkgCtrl of selectedPackages.controls) {
      const pkgId = pkgCtrl.get('package_id')?.value;
      const purchases = pkgCtrl.get('purchased') as FormArray;
      const pkg = this.travel.price_packages.find((p) => p.id === pkgId);

      if (!pkg || !purchases) continue;

      for (let purchaseCtrl of purchases.controls) {
        const n_adults = purchaseCtrl.get('n_adults')?.value || 0;
        const n_children = purchaseCtrl.get('n_children')?.value || 0;
        const n_infants = purchaseCtrl.get('n_infants')?.value || 0;

        const purchaseTotal =
          n_adults * (pkg.price_per_person || 0) +
          n_children * (pkg.price_per_children || 0) +
          n_infants * (pkg.price_per_infant || 0);

        fullTotal += purchaseTotal;
        tot_participants += n_adults + n_children + n_infants;

        if (this.travel.checkout_advance) {
          // L'acconto si calcola solo sugli adulti
          advanceTotal += this.travel.checkout_advance * n_adults;
        }
        if (this.purchased_with_optional_flight.value === true) {
          fullTotal -= this.travel?.optional_flight_purchase_discount!;
        }
      }
    }

    if (
      this.travel!.availability!.max <
      (this.travel!.availability!.booked || 0) + tot_participants
    ) {
      this.overbooking = true;
    } else {
      this.overbooking = false;
    }

    return { advanceTotal, fullTotal, tot_participants };
  }

  getFrmMembersControls(i: number) {
    return <FormGroup[]>(
      (this.frmRoomsControls[i].get('members') as FormArray).controls
    );
  }
  getFrmMembers(i: number) {
    return this.frmRoomsControls[i].get('members') as FormArray;
  }
  get frmAddlService() {
    return this.frmJoin.get('addl_service') as FormArray;
  }
  get frmAddlServiceControls() {
    return <FormGroup[]>(
      (this.frmJoin.get('addl_service') as FormArray).controls
    );
  }

  addRoom() {
    const frm = new FormGroup({
      n_adults: new FormControl<number>(2, Validators.required),
      members: new FormArray<FormGroup>([]),
      n_children: new FormControl<number>(0),
      n_infants: new FormControl<number>(0),
      room_type: new FormControl<number>(2),
      dbl_type: new FormControl<number>(1),
      price_room: new FormControl<number>(0),
    });
    (this.frmJoin.get('rooms') as FormArray)!.push(frm);

    const room = frm;

    this.setRoomsTypeAndPrice(
      room,
      room.get('n_adults')?.value!,
      room.get('n_children')?.value!,
      room.get('n_infants')?.value!,
    );

    room.get('n_adults')?.valueChanges.subscribe((s) => {
      this.setRoomsTypeAndPrice(room, s!, 0, 0);
    });
    room.get('n_children')?.valueChanges.subscribe((s) => {
      this.setMembersFormGroupsInRoom(
        this.getNumberOfMembersInRoom(room),
        this.frmRoomsControls.length - 1,
      );
    });
    room.get('n_infants')?.valueChanges.subscribe((s) => {
      this.setMembersFormGroupsInRoom(
        this.getNumberOfMembersInRoom(room),
        this.frmRoomsControls.length - 1,
      );
    });
    this.checkForAvailability();
  }

  getNumberOfMembersInRoom(room: FormGroup) {
    return (
      room.get('n_adults')!.value +
      room.get('n_children')!.value +
      room.get('n_infants')!.value
    );
  }

  remove(index: number, frm: FormArray) {
    frm.removeAt(index);
    this.checkForAvailability();
  }

  setRoomsTypeAndPrice(
    room: FormGroup,
    adults: number,
    children: number,
    infants: number,
  ) {
    if (adults === 1) {
      room.get('room_type')?.setValue(enumRoomType.SGL); //singola
      room
        .get('price_room')
        ?.setValue(this.travel!.price_room + this.travel!.price_addl_single);
    } else if (adults === 2) {
      room.get('room_type')?.setValue(enumRoomType.DBL); //matrimoniale o doppia
      room.get('price_room')?.setValue(this.travel!.price_room);
    } else if (adults === 3) {
      room.get('room_type')?.setValue(enumRoomType.TRP); //tripla
      room
        .get('price_room')
        ?.setValue(this.travel!.price_room - this.travel!.price_sub_triple);
    } else if (adults === 4) {
      room.get('room_type')?.setValue(enumRoomType.QUD); //quadrupla
      room
        .get('price_room')
        ?.setValue(this.travel!.price_room - this.travel!.price_sub_quad);
    }

    if (children > 0) {
      room
        .get('price_room')
        ?.setValue(
          (room.get('price_room')?.value - this.travel!.price_sub_child) *
            children,
        );
    }
    if (infants > 0) {
      room
        .get('price_room')
        ?.setValue(
          (room.get('price_room')?.value - this.travel!.price_sub_infant) *
            infants,
        );
    }

    this.setMembersFormGroupsInRoom(
      this.getNumberOfMembersInRoom(room),
      this.frmRoomsControls.length - 1,
    );
  }

  setMembersFormGroupsInRoom(howMany: number, roomIndex: number) {
    this.getFrmMembers(roomIndex).clear();
    for (let i = 0; i < howMany; i++) {
      const frm = new FormGroup({
        name: new FormControl(undefined, Validators.required),
        last_name: new FormControl(undefined, Validators.required),
        date_of_birth: new FormControl(undefined, Validators.required),
        fiscal_code: new FormControl(undefined),
        gender: new FormControl(undefined, Validators.required),
        disabled: new FormControl<boolean>(false, Validators.required),
        document_type: new FormControl(undefined, Validators.required),
        document_number: new FormControl(undefined, Validators.required),
        document_exp_date: new FormControl(undefined, Validators.required),
        document_release_date: new FormControl(undefined, Validators.required),
        nationality: new FormControl(undefined, Validators.required),
        phone_number: new FormControl(undefined, Validators.required),
        email_address: new FormControl(undefined, [
          Validators.required,
          Validators.email,
        ]),
        tmp_account_holder_guest: new FormControl<boolean>(false),
      });
      this.getFrmMembers(roomIndex).push(frm);
    }
  }

  addService(i: number) {
    const frm = new FormGroup({
      title: new FormControl(this.travel!.addl_services[i].title),
      price: new FormControl(this.travel!.addl_services[i].price),
      qty: new FormControl(0),
    });
    (this.frmJoin.get('addl_service') as FormArray)!.push(frm);
  }

  increasePeople(index: number) {
    const members = this.frmAddlService.at(index).get('qty')!;
    members.setValue(members.value + 1);
  }

  decreasePeople(index: number) {
    const members = this.frmAddlService.at(index).get('qty')!;
    if (members.value > 0) {
      members.setValue(members.value - 1);
    }
  }

  get addlServiceTotal() {
    let total = 0;
    for (let b of this.frmAddlService.controls) {
      total += b.value.price * b.value.qty;
    }
    return total;
  }

  getaddlServiceMembersTotal(i: number) {
    let total = 0;
    if (this.frmAddlServiceControls[i].get('qty')?.value > 0) {
      total += this.frmAddlServiceControls[i].get('qty')?.value;
      return total;
    } else {
      return total;
    }
  }

  paymentMethod(m: enumPaymentMethod) {
    switch (m) {
      case enumPaymentMethod.STRIPE_ADVANCE:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_ADVANCE);
        break;
      case enumPaymentMethod.STRIPE_TRANSFER:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_TRANSFER);
        break;
      case enumPaymentMethod.BANK_TRANSFER_ADV:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.BANK_TRANSFER_ADV);
        break;
      case enumPaymentMethod.BANK_TRANSFER_PAYOFF:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.BANK_TRANSFER_PAYOFF);
        break;
      case enumPaymentMethod.CASH_ADV:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.CASH_ADV);
        break;
      case enumPaymentMethod.CASH_PAYOFF:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.CASH_PAYOFF);
        break;
    }
  }

  isPaymentAvailable() {
    const today = new Date();
    const nextMonth = addDays(today, 31);
    if (this.travel!.from_date < nextMonth.toISOString()) {
      this.frmJoin
        .get('payment_method')
        ?.setValue(enumPaymentMethod.BANK_TRANSFER_ADV);
      return false;
    } else {
      return true;
    }
  }

  checkHolderGuest(roomIndex: number, memberIndex: number) {
    const membersControls = this.getFrmMembers(roomIndex).controls;
    if (
      this.getFrmMembersControls(roomIndex)[memberIndex].get(
        'tmp_account_holder_guest',
      )?.value === true
    ) {
      this.frmJoin
        .get('accountholder_name')
        ?.setValue(
          this.getFrmMembersControls(roomIndex)[memberIndex].get('name')?.value,
        );
      this.frmJoin
        .get('accountholder_last_name')
        ?.setValue(
          this.getFrmMembersControls(roomIndex)[memberIndex].get('last_name')
            ?.value,
        );

      membersControls.forEach((control, index) => {
        if (index !== memberIndex) {
          control
            .get('tmp_account_holder_guest')
            ?.setValue(false, { emitEvent: false });
        }
      });
    } else {
      this.frmJoin.get('accountholder_name')?.setValue(undefined);
      this.frmJoin.get('accountholder_last_name')?.setValue(undefined);
    }
  }

  submit() {
    if (this.isGuest) {
      this.frmJoin.get('third_party_booking')?.setValue(true);
    }

    // if (this.frmJoin.get('third_party_booking')?.value === false) {
    //   // if (this.travel?.checkout_advance) {
    //   //   this.frmJoin
    //   //     .get('payment_method')
    //   //     ?.setValue(enumPaymentMethod.STRIPE_ADVANCE);
    //   // } else {
    //   //   this.frmJoin
    //   //     .get('payment_method')
    //   //     ?.setValue(enumPaymentMethod.STRIPE_TRANSFER);
    //   // }

    //   if (this.isOnlyFullPayment()) {
    //     this.frmJoin
    //       .get('payment_method')
    //       ?.setValue(enumPaymentMethod.STRIPE_ADVANCE); //saldo
    //   }
    //   if (
    //     (this.isBeforeDeadline() && this.isBeforePayoffDueDate()) ||
    //     this.travel!.booking_deadline
    //   ) {
    //     this.frmJoin
    //       .get('payment_method')
    //       ?.setValue(enumPaymentMethod.STRIPE_TRANSFER); //acconto e saldo
    //   }
    // }

    if (this.travel?.pricing_mode === 1) {
      for (let r of this.frmRoomsControls) {
        for (let m of r.controls['members'].value) {
          m.date_of_birth = correctDate(m.date_of_birth).toISOString();
          m.document_exp_date = correctDate(m.document_exp_date).toISOString();
          m.document_release_date = correctDate(
            m.document_release_date,
          ).toISOString();
          delete m.tmp_account_holder_guest;
        }
      }
    } else {
      for (let pckg of this.frmSelectedPackageControls) {
        for (let purchase of pckg.get('purchased')!.value) {
          for (let member of purchase.members) {
            member.date_of_birth = correctDate(
              member.date_of_birth,
            ).toISOString();
            member.document_exp_date = correctDate(
              member.document_exp_date,
            ).toISOString();
            member.document_release_date = correctDate(
              member.document_release_date,
            ).toISOString();
          }
        }
      }
    }

    const frmJoin = this.frmJoin.value;

    //Delete del campo is account holder e related_package_id
    if (this.travel?.pricing_mode === 2) {
      frmJoin.selected_packages!.forEach((pkg) => {
        pkg.purchased!.forEach((purchase) => {
          purchase.members!.forEach((member) => {
            delete member.is_account_holder;
            delete purchase.related_package_id;
          });
        });
      });
    }

    const body: DtoTravelBookingCreate = frmJoin as any;

    const country_obj = this.frmJoin.get('accountholder_country_iso')!.value!;
    body.accountholder_country_iso = country_obj.ISO;

    // console.log(body);

    this.loading = true;
    this.bookingService
      .bookingControllerCreate({
        travel_id: this.travel?.id!,
        body: body,
      })
      .subscribe({
        next: (res) => {
          this.loading = true;
          window.location.href = res.data.redirect_url;
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Prenotazione viaggio',
            detail: "Impossibile completare l'operazione.",
          });
        },
      });
  }

  get frmSelectedPackages() {
    return this.frmJoin.get('selected_packages') as FormArray;
  }
  get frmSelectedPackageControls(): FormGroup[] {
    const arr = this.frmJoin.get('selected_packages') as FormArray;
    return arr.controls.filter(
      (ctrl): ctrl is FormGroup => ctrl instanceof FormGroup,
    );
  }
  getFrmMembersControlsForPckgsById(
    packageId: number,
    purchaseIndex: number,
  ): FormGroup[] {
    const pkgFormGroup = this.frmSelectedPackages.controls.find(
      (ctrl) => ctrl.get('package_id')?.value === packageId,
    ) as FormGroup;

    if (!pkgFormGroup) return [];

    const purchasedArray = pkgFormGroup.get('purchased') as FormArray;
    const purchaseGroup = purchasedArray?.at(purchaseIndex) as FormGroup;
    const membersArray = purchaseGroup?.get('members') as FormArray;

    return membersArray?.controls.filter(
      (ctrl) => ctrl instanceof FormGroup,
    ) as FormGroup[];
  }

  getFrmMembersForPckgs(pkgIndex: number, purchaseIndex: number): FormArray {
    return this.frmSelectedPackages
      .at(pkgIndex)
      .get('purchased')!
      .get([purchaseIndex])!
      .get('members') as FormArray;
  }

  selectPackage(packageId: number): void {
    // Recupero dati pacchetto
    const pkg = this.packageMap.get(packageId);
    if (!pkg) {
      return;
    }

    // Cerco se il pacchetto è già stato selezionato
    const existingPkgIndex = this.frmSelectedPackages.controls.findIndex(
      (ctrl) => ctrl.get('package_id')?.value === packageId,
    );

    let pkgGroup: FormGroup;

    if (existingPkgIndex === -1) {
      //Se non c’è ancora, creo il gruppo e lo pusho
      pkgGroup = new FormGroup({
        package_id: new FormControl<number>(packageId, Validators.required),
        purchased: new FormArray<FormGroup>([]),
      });
      this.frmSelectedPackages.push(pkgGroup);
    } else {
      // Se esiste già
      pkgGroup = this.frmSelectedPackages.at(existingPkgIndex) as FormGroup;
    }

    // Verifica limiti prenotazioni
    const purchasedArray = pkgGroup.get('purchased') as FormArray;
    if (pkg.max_bookings != null && purchasedArray.length >= pkg.max_bookings) {
      this.maxMembersExceededMap.set(packageId, true);
      return;
    }

    // Creo un nuovo purchase e lo aggiungo
    const purchaseGroup = new FormGroup({
      related_package_id: new FormControl(packageId, Validators.required),
      price_per_person: new FormControl(
        pkg.price_per_person,
        Validators.required,
      ),
      price_per_children: new FormControl(
        pkg.price_per_children,
        Validators.required,
      ),
      price_per_infants: new FormControl(
        pkg.price_per_infant,
        Validators.required,
      ),
      n_adults: new FormControl(pkg.n_partecipants || 1, [
        Validators.required,
        this.multipleOf(pkg.n_partecipants || 1),
      ]),
      n_children: new FormControl(0, Validators.required),
      n_infants: new FormControl(0, Validators.required),
      notes: new FormControl<string | undefined>(undefined),
      members: new FormArray<FormGroup>([]),
    });

    purchasedArray.push(purchaseGroup);

    // Popolo l’array members usando i parametri
    const purchaseIndex = purchasedArray.length - 1;
    this.updateMembersForPurchase(packageId, purchaseIndex);

    // Aggiorno la mappa dei limiti
    const isNowExceeded =
      pkg.max_bookings != null && purchasedArray.length >= pkg.max_bookings;

    this.maxMembersExceededMap.set(packageId, isNowExceeded);
  }

  // hasExceededLimit(package_id: number) {
  //   return this.maxMembersExceededMap.get(package_id) === true;
  // }

  removePurchase(pkgIndex: number, purchaseIndex: number) {
    const pkgId = this.travel?.price_packages![pkgIndex]?.id;

    if (!pkgId) return;

    const pkgFormGroup = this.frmSelectedPackages.controls.find(
      (ctrl) => ctrl.get('package_id')?.value === pkgId,
    ) as FormGroup;

    if (!pkgFormGroup) return;

    const purchasedArray = pkgFormGroup.get('purchased') as FormArray;

    if (purchasedArray && purchasedArray.length > purchaseIndex) {
      purchasedArray.removeAt(purchaseIndex);

      if (purchasedArray.length === 0) {
        // Se non ci sono più acquisti, rimuovo il pacchetto
        this.frmSelectedPackages.removeAt(pkgIndex);
      }

      const pkg = this.packageMap.get(pkgId);
      if (pkg && pkg.max_bookings) {
        const isNowExceeded = purchasedArray.length >= pkg.max_bookings;
        this.maxMembersExceededMap.set(pkgId, isNowExceeded);
      }
    }
  }

  checkMaxNumberOfKids(package_id: number, type: string) {
    const selectedPackage = this.travel!.price_packages!.find(
      (x) => x.id === package_id,
    );
    if (!selectedPackage) return 0;

    if (type === 'children') {
      return selectedPackage.max_n_children;
    }
    if (type === 'infants') {
      return selectedPackage.max_n_infants;
    }
    return 0;
  }

  checkMinNumberOfAdults(package_id: number) {
    const selectedPackage = this.travel!.price_packages!.find(
      (x) => x.id === package_id,
    );
    if (!selectedPackage) return false;

    return selectedPackage.n_partecipants;
  }

  validatePackageInput(
    event: Event,
    packageId: number,
    purchaseIndex: number,
    field: 'n_adults' | 'n_children' | 'n_infants',
  ) {
    const input = event.target as HTMLInputElement;
    const value = parseInt(input.value, 10);

    const pkg = this.packageMap.get(packageId);
    if (!pkg) return;

    // const selectedPackages = this.frmJoin.get('selected_packages') as FormArray;
    // const selectedPackageGroup = selectedPackages.at(
    //   selectedPackageIndex
    // ) as FormGroup;

    // const purchasedArray = selectedPackageGroup.get('purchased') as FormArray;
    // const purchaseGroup = purchasedArray.at(purchaseIndex) as FormGroup;

    const selectedPackages = this.frmJoin.get('selected_packages') as FormArray;

    // Trova l’indice reale nel FormArray
    const selectedPackageIndex = selectedPackages.controls.findIndex(
      (g) => g.get('package_id')?.value === packageId,
    );
    if (selectedPackageIndex === -1) {
      console.warn(`Pacchetto ${packageId} non trovato nel form`);
      return;
    }

    const selectedPackageGroup = selectedPackages.at(
      selectedPackageIndex,
    ) as FormGroup;
    const purchasedArray = selectedPackageGroup.get('purchased') as FormArray;
    const purchaseGroup = purchasedArray.at(purchaseIndex) as FormGroup;
    const control = purchaseGroup.get(field);
    if (!control) {
      return;
    }

    // const control = purchaseGroup.get(field);
    if (!control) return;

    let errorMsg = '';

    // Controllo adulti (multipli)
    if (field === 'n_adults') {
      const step = pkg.n_partecipants || 1;
      if (!isNaN(value) && value % step !== 0) {
        errorMsg = `Il numero deve essere un multiplo di ${step}`;
      }
    }

    // Controllo bambini
    if (field === 'n_children') {
      if (!isNaN(value) && value > pkg.max_n_children) {
        errorMsg = `Puoi inserire al massimo ${pkg.max_n_children} bambino/i`;
      }
    }

    // Controllo infanti
    if (field === 'n_infants') {
      if (!isNaN(value) && value > pkg.max_n_infants) {
        errorMsg = `Puoi inserire al massimo ${pkg.max_n_infants} neonato/i`;
      }
    }

    if (errorMsg) {
      input.setCustomValidity(errorMsg);
      control.setErrors({ custom: { message: errorMsg } });
    } else {
      input.setCustomValidity('');
      control.setErrors(null);
    }

    control.markAsTouched();
  }

  multipleOf(multiple: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || value === '') return null;
      return value % multiple === 0 ? null : { notMultipleOf: multiple };
    };
  }

  getPackageControls(package_id: number): FormArray<FormGroup> {
    const index = this.frmSelectedPackages.controls.findIndex(
      (ctrl) => ctrl.get('package_id')?.value === package_id,
    );

    if (index === -1) return new FormArray<FormGroup>([]);

    return this.frmSelectedPackages
      .at(index)
      .get('purchased') as FormArray<FormGroup>;
  }

  createMemberFormGroup(
    member_type: 'Adulto' | 'Bambino' | 'Neonato',
  ): FormGroup {
    return new FormGroup({
      name: new FormControl(undefined, Validators.required),
      last_name: new FormControl(undefined, Validators.required),
      date_of_birth: new FormControl(undefined, Validators.required),
      gender: new FormControl(null, Validators.required),
      document_type: new FormControl(null, Validators.required),
      document_exp_date: new FormControl(undefined, Validators.required),
      document_number: new FormControl(undefined, Validators.required),
      document_release_date: new FormControl(undefined, Validators.required),
      nationality: new FormControl(undefined, Validators.required),
      phone_number: new FormControl(undefined, Validators.required),
      email_address: new FormControl(undefined, [
        Validators.required,
        Validators.email,
      ]),
      disabled: new FormControl(false),
      is_account_holder: new FormControl(false),
      member_type: new FormControl(member_type),
    });
  }

  updateMembersForPurchase(packageId: number, purchaseIndex: number) {
    // const selectedPackage = this.frmSelectedPackages.at(pkgIndex);
    // const purchase = (selectedPackage.get('purchased') as FormArray).at(
    //   purchaseIndex
    // ) as FormGroup;
    const selectedPackages = this.frmJoin.get('selected_packages') as FormArray;

    // Trova la posizione del pacchetto nel FormArray
    const pkgIndex = selectedPackages.controls.findIndex(
      (g) => g.get('package_id')?.value === packageId,
    );

    if (pkgIndex === -1) {
      console.warn(`Pacchetto ${packageId} non presente in selected_packages`);
      return;
    }

    const selectedPackage = selectedPackages.at(pkgIndex) as FormGroup;
    const purchasedArray = selectedPackage.get('purchased') as FormArray;
    const purchase = purchasedArray.at(purchaseIndex) as FormGroup;
    if (!purchase) {
      console.warn(
        `Purchase index ${purchaseIndex} non valido per il pacchetto ${packageId}`,
      );
      return;
    }

    const membersArray = purchase.get('members') as FormArray;
    membersArray.clear();

    const n_adults = purchase.get('n_adults')?.value || 0;
    let n_children = purchase.get('n_children')?.value || 0;
    let n_infants = purchase.get('n_infants')?.value || 0;

    const pkg = this.packageMap.get(packageId);
    if (!pkg) {
      return;
    }

    // Applica i limiti
    if (n_children > pkg.max_n_children) {
      n_children = pkg.max_n_children;
      purchase.get('n_children')?.setValue(n_children);
    }

    if (n_infants > pkg.max_n_infants) {
      n_infants = pkg.max_n_infants;
      purchase.get('n_infants')?.setValue(n_infants);
    }

    // Aggiunta adulti
    for (let i = 0; i < n_adults; i++) {
      membersArray.push(this.createMemberFormGroup('Adulto'));
    }

    // Aggiunta bambini
    for (let i = 0; i < n_children; i++) {
      membersArray.push(this.createMemberFormGroup('Bambino'));
    }

    // Aggiunta infanti
    for (let i = 0; i < n_infants; i++) {
      membersArray.push(this.createMemberFormGroup('Neonato'));
    }
  }

  onTabToggle(index: number, isSelected: boolean) {
    this.expandedTabIndex = isSelected ? index : null;
  }
  //intestatario pratica
  setAccountHolderPckgs(
    pkgIndex: number,
    purchaseIndex: number,
    memberIndex: number,
  ) {
    const pkgId = this.travel?.price_packages![pkgIndex]?.id;
    if (!pkgId) return;

    const membersControls = this.getFrmMembersControlsForPckgsById(
      pkgId,
      purchaseIndex,
    );

    const selectedMember = membersControls[memberIndex];
    if (!selectedMember) return;

    const isAccountHolder =
      selectedMember.get('is_account_holder')?.value === true;

    if (isAccountHolder) {
      this.frmJoin
        .get('accountholder_name')
        ?.setValue(selectedMember.get('name')?.value);
      this.frmJoin
        .get('accountholder_last_name')
        ?.setValue(selectedMember.get('last_name')?.value);

      // Deseleziona gli altri
      membersControls.forEach((control, index) => {
        if (index !== memberIndex) {
          control
            .get('is_account_holder')
            ?.setValue(false, { emitEvent: false });
        }
      });
    } else {
      this.frmJoin.get('accountholder_name')?.setValue(undefined);
      this.frmJoin.get('accountholder_last_name')?.setValue(undefined);
    }
  }

  get isPaymentDisabled(): boolean {
    if (this.frmSelectedPackages.length === 0) return true;

    const anyInvalidPurchase = this.frmSelectedPackages.controls.some(
      (pkgCtrl) => {
        const purchasedArray = pkgCtrl.get('purchased') as FormArray;
        if (!purchasedArray || purchasedArray.length === 0) return true;

        return purchasedArray.controls.some((purchaseCtrl) => {
          if (purchaseCtrl.invalid) return true;

          const members = purchaseCtrl.get('members') as FormArray;
          return !members || members.length === 0 || members.invalid;
        });
      },
    );

    const anyMaxExceeded = Array.from(this.maxMembersExceededMap.values()).some(
      (v) => v,
    );

    return anyInvalidPurchase || anyMaxExceeded;
  }

  getFormValidationErrors() {
    const e: { key: string; keyError: string; e: any }[] = [];
    Object.keys(this.frmJoin.controls).forEach((key) => {
      const controlErrors: ValidationErrors | null =
        this.frmJoin.get(key)!.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          //  console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          e.push({ key, keyError, e: controlErrors[keyError] });
        });
      }
    });
    return e;
  }

  checkIfIsDblRoom(name: string) {
    // se il name di p contiene la stringa 'camera doppia' (case insensitive) ritorna true
    return name.toLowerCase().includes('camera doppia');
  }
}
